import React from 'react';

import PropTypes from 'prop-types';
import {List, Avatar} from 'antd';
import './NotificationItem.less';
import {
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineInfoCircle,
  AiOutlineWarning,
} from 'react-icons/ai';

const NotificationItem = (props) => {
  const {item} = props;
  const title = item.type === 2 ? 'Trading Event' : 'General Event';
  let icon;
  let style = {paddingTop: '7px'};
  if (item.level === 2) {
    icon = <AiOutlineWarning color={'orange'} size={'34'} />;
    style = {paddingTop: '2px'};
  } else if (item.level === 3) {
    icon = <AiOutlineCheckCircle color={'green'} size={'34'} />;
  } else if (item.level === 4) {
    icon = <AiOutlineCloseCircle color={'red'} size={'34'} />;
  } else {
    icon = <AiOutlineInfoCircle color={'blue'} size={'34'} />;
  }

  return (
    <List.Item className='notify-listItem item-hover'>
      <List.Item.Meta
        avatar={
          <Avatar className='notify-message-avatar' src={icon} style={style} />
        }
        title={title}
        description={item.message}
      />
    </List.Item>
  );
};

export default NotificationItem;

NotificationItem.propTypes = {
  item: PropTypes.object.isRequired,
};
